export default function getBatteryGradeLetter(grade: number | null): string {
  if (grade >= 90) return "a";
  if (grade >= 80) return "b";
  if (grade >= 70) return "c";
  if (grade >= 60) return "d";
  if (grade >= 50) return "e";

  return "x";
}
